<template>
    <div>
      <div ref="input" class="dropdown-selection" @click.stop="onInputClick">
        <span class="label placeholder" v-if="isEmpty && !searchingText">{{placeholder}}</span>

        <!-- show selected options -->
        <template>
          <template>
            <ul class="tags">
<!--              <li class="selection" v-for="(item, idx) in items">-->
<!--                <span class="remove-btn"-->
<!--                      v-if="item.removable"-->
<!--                      @click.stop="onRemoveItemClick(idx)">×</span>-->
<!--                {{item.value}}-->
<!--              </li>-->

              <template v-for="item in items">
                <li class="selection">
                  <v-popover class="d-inline-block" v-if="item.items">
                      <span class="remove-btn"
                            v-if="item.removable"
                            @click.stop="onRemoveItemClick(item.idx)">×</span>
                      <span class="grouped-item">{{item.value}}</span>
                    <template slot="popover">
                      <div v-for="record in item.items">
                        {{record.value}}
                        <span class="remove-btn"
                              v-if="record.removable && !disabled"
                              @click.stop="onRemoveItemClick(record.idx)">×</span>
                      </div>
                    </template>
                  </v-popover>
                  <template v-else>
                    <span class="remove-btn"
                          v-if="item.removable && !disabled"
                          @click.stop="onRemoveItemClick(item.idx)">×</span>
                    <span class="single-item">
                      {{item.value}}
                    </span>
                  </template>
                </li>
              </template>

              <li class="search-input" v-if="!disabled">
                <!-- livesearch enabled-->
                <input ref="search"
                       class="search"
                       :style="{'width': (1.03 * searchingText.length) + 'em'}"
                       v-model="searchingText"
                       @keypress.enter="handleInput(true)"
                       @paste.prevent="handlePaste"
                       @input="handleInput(false)"
                       @blur="handleInput(true)"
                       @click.self.prevent>
              </li>
            </ul>
          </template>
        </template>
      </div>
    </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      value: {
        type: [Array]
      },

      placeholder: {
        type: String
      },

      validator: {
        type: Function,
        default: () => true
      },

      mutator: {
        type: Function,
        default: items => {
          return (items || []).map(e => ({
            removable: true,
            value: e
          }))
        }
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      searchingText: ''
    }),

    computed: {
      isEmpty() {
        return !this.value || this.value.length === 0;
      },

      items() {
        return this.mutator(this.value);
      }
    },

    methods: {
      handlePaste(event) {
        this.searchingText = (event.clipboardData || window.clipboardData).getData('text');
        this.handleInput(true);
      },

      handleInput(isFinished) {
        const nbOfValues = this.value.length;
        let str = this.searchingText;

        const elems = str.split(' ');
        let output = [];

        for (let i = 0; i < elems.length; ++i) {
          if (!isFinished && i === elems.length - 1) {
            output.push(elems[i]);
            continue
          }

          if (this.validator(elems[i])) {
            this.value.push(elems[i]);
          }
          else {
            output.push(elems[i]);
          }
        }

        this.searchingText = output.join(' ');

        if (this.value.length != nbOfValues) {
          this.$emit('input', this.value);
          this.$emit('change');
        }
      },

      onInputClick() {
        this.$refs.search.focus();
      },

      onRemoveItemClick(idx) {
        const value = [...this.value];
        value.splice(idx, 1);

        this.$emit('input', value);
        this.$emit('change');
      }
    }
  }
</script>

<style lang="scss" scoped>

  .dropdown-selection {
    background: white;
    position: relative;
    cursor: pointer;
    width: 100%;
    text-align: left;

    .label {
      display: inline-block;
      overflow: hidden;
      margin: 0 26px 0 0;
      padding: 3px 0 3px 12px;
      font-size: 18px;
      color: #666666;
      text-align: left;
      font-weight: 400;
      line-height: inherit;
      min-height: 34px;
      height: 100%;
      user-select: none;
    }

    .search {
      border: none!important;
      background: none!important;
      outline: none!important;
      display: inline-block;
      width: 100%;
      height: 100%;
      font-size: 18px;

      &::-ms-clear {
        display: none;
      }

      &.hidden {
        display: none!important;
      }
    }

  .placeholder {
    color: #B2B2B2;
    position: absolute;
    left: 0px;
    line-height: 17px;
    display: inline-flex;
    align-items: center;
  }

  .selected {
    position: absolute;
    left: 0px;
    line-height: 17px;
    display: inline-flex;
    align-items: center;
  }

    ul.tags {
      padding:  8px 0 8px 12px;
      display: inline-block;
      min-height: 34px;

      li {
        list-style: none;
        border: 0;
        cursor: default;
        float: left;
        margin-right: 5px;
        margin-top: 2px;
        font-size: 18px;

        &.selection {
          border-radius: 13px;
          background-color: #f2f2f2;
          padding: 4px 11px;
        }

        &.search-input {
          .search {
            min-width: 1em;
            box-sizing: content-box;
          }
        }

        &.empty {
          clear: both;
          float: none;
          padding: 0px;
        }

        .remove-btn {
          position: relative;
          top: -6px;
          display: inline-block;
          float: right;
          margin-left: 12px;
          height: 12px;
          color: #e30611;
          cursor: pointer;
          font-size: 27px;
          line-height: 10px;
          cursor: pointer;
          z-index: 20;
          top: 3px;
        }
      }
    }
  }

  .remove-btn {
    position: relative;
    top: -6px;
    display: inline-block;
    float: right;
    margin-left: 12px;
    height: 12px;
    color: #e30611;
    cursor: pointer;
    font-size: 27px;
    line-height: 10px;
    cursor: pointer;
    z-index: 20;
    top: 3px;
  }

</style>
